import { TextInput } from "@msuite/ui/form";
import { useSearchForm } from "@msuite/ui/hooks";
import { useEffect } from "react";

/** Props Interface */
interface AbsencesSearchProps {
	onSearch: (value: string) => void;
}

export function AbsencesSearch({ onSearch }: AbsencesSearchProps) {
	/** Hooks */
	const searchForm = useSearchForm("", 300, true);

	/** Effects */
	useEffect(() => {
		onSearch(searchForm.searchValue);
	}, [searchForm.searchValue]);

	/** Render */
	return <TextInput {...searchForm.getSearchInputProps()} />;
}
